import script from "./FoundErrorThanksModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FoundErrorThanksModal.vue?vue&type=script&setup=true&lang=ts"

import "./FoundErrorThanksModal.vue?vue&type=style&index=0&id=2349015d&scoped=true&lang=css"
import "./FoundErrorThanksModal.vue?vue&type=style&index=1&id=2349015d&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2349015d"]])

export default __exports__